/**
 * Created by vladislav on 1/26/2024
 */

const SPMobageLogic = function () {
    PlatformLogic.call(this);

    if (typeof TacticalExtendWindow !== "undefined") {
        TacticalExtendWindow.AMOUNT = 5;
    }

    this.loginScreenShown = false;

    connector.social.on("login", this.closeLoginScreen.bind(this));
};

SPMobageLogic.prototype = Object.create(PlatformLogic.prototype);
SPMobageLogic.prototype.constructor = SPMobageLogic;

SPMobageLogic.prototype.showLoginScreen = function (callback) {
    if (this.loginScreenShown) {
        callback();
        return;
    }

    this.loginScreenShown = true;

    if (connector.social.isLoggedIn()) {
        callback();
        return;
    }

    this.callback = callback;

    const waitingList = ResourceProcessor.calcAlwaysNeed();

    const interval = cleverapps.timeouts.setInterval(() => {
        if (!cleverapps.bundleLoader.isLoaded(waitingList)) {
            return;
        }

        cleverapps.timeouts.clearInterval(interval);

        this.createLoginScreen();
    }, 300);
};

SPMobageLogic.prototype.closeLoginScreen = function () {
    if (this.overlay) {
        this.overlay.removeFromParent();
        delete this.overlay;
    }

    if (this.callback) {
        this.callback();
        delete this.callback;
    }
};

SPMobageLogic.prototype.createLoginScreen = function () {
    const size = cleverapps.resolution.getSceneSize();
    this.overlay = new cc.Scale9Sprite(bundles.pixel.frames.pixel_png);
    this.overlay.setContentSize(size.width, size.height);
    this.overlay.setAnchorPoint(0, 0);
    this.overlay.setColor(cleverapps.styles.COLORS.WHITE);
    this.overlay.onResize = function () {
        const newSize = cleverapps.resolution.getSceneSize();
        this.overlay.setContentSize2(newSize);
        this.overlay.buttonNode.setAlignment(newSize.width / 2, newSize.height / 2);
    }.bind(this);
    cleverapps.Scenes.GetRunningScene().addChild(this.overlay, 9999);

    const buttonNode = this.overlay.buttonNode = new SpPlatformButtons(size.width, ((options) => {
        if (connector.social.isConnected()) {
            connector.social.loginCallback((success) => {
                if (success) {
                    this.closeLoginScreen();
                } else {
                    cleverapps.SocialManager.onFailedLogin();
                }
            }, options);
        } else {
            cleverapps.notification.create(Messages.get("SocialManager.Initialization"));
        }
    }));

    this.overlay.addChild(buttonNode);
    buttonNode.setAlignment(size.width / 2, size.height / 2);
};